import React from "react";
import useForm from './form'
// import Grid from '@mui/material/Grid';
// import { Grid, MenuItem, Box, Button, TextField, Modal } from '@material-ui/core';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
// import Item from '@mui/material/Grid';
// import Modal from '@mui/material/Modal';
// import TextField from '@mui/material/TextField';
// import MenuItem from '@mui/material/MenuItem';
// import Box from '@mui/material/Box';
import styles from './add_robot_form.module.css';
import { useMountEffect } from '../../utils/hooks'; // Import the new CSS module
// import { Button } from '@mui/material';

let robot_softwares = []
let robot_sites = []
let robot_types = []
let robot_versions = []
const robot_maps = ["Current"]

export default function AddRobotModel(props) {

  const getFormInitials = () => {
    Promise.all([
      props.apiConfig.fetchAllRobotTypes(),
      props.apiConfig.fetchAllRobotSites(),
      props.apiConfig.fetchAllRobotSoftwareVersions(),
      props.apiConfig.fetchAllRobotVersions()
    ]).then(results => {
      robot_types = results[0].RobotResponse
      robot_sites = results[1].RobotResponse
      robot_softwares = results[2].RobotResponse
      robot_versions = results[3].RobotResponse
    }).catch(error => {
      console.error(error);
    });
  }

  useMountEffect(() => {
    getFormInitials()
  }, []);

  var robot = {
    Id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    RobotId: "string",
    RobotTypeId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    RobotSiteId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    RobotVersionId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    FabricationDate: "2023-10-10T04:51:45.062Z",
    DeployedDate: "2023-10-10T04:51:45.062Z",
    DecomDate: "2023-10-10T04:51:45.062Z",
    CreatedAt: "2023-10-10T04:51:45.062Z",
    UpdatedAt: "2023-10-10T04:51:45.062Z",
    CreatedBy: "string",
    UpdatedBy: "string",
    RegistrationDate: "2023-10-10T04:51:45.062Z",
    RobotSoftwareId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    RegistrationKey: "string",
    Status: "string",
    ActivationStatus: false
  }

  const formSubmit = () => {

    console.log("Callback function when form is submitted!");
    console.log("Form Values ", values);
    robot.RobotId = values.robot_id
    robot.RobotSiteId = values.robot_site
    robot.RobotTypeId = values.robot_type
    robot.RobotSoftwareId = values.robot_software
    robot.RobotVersionId = values.robot_version
    props.addRobots(robot)
    props.handleClose()
    handleClose()
  }
  const {handleChange, values,handleClose} = useForm(formSubmit);
  const formClose = () => {
    props.handleClose()
    handleClose()
  }

  return(
    <Modal
    open={props.open_new_robot}
    onClose={props.handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
  >
    <Box
      component="form"
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90%', sm: '70%', md: '60%', lg: '50%' }, // Responsive widths
        maxWidth: '600px', // Max width on larger screens
        bgcolor: 'background.paper',
        border: '2px solid',
        borderColor: 'divider',
        borderRadius: 10,
        boxShadow: 24,
        p: { xs: 2, md: 4 },
        overflowY: "auto",
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <p className={styles.modalTitle}>Register New Robot</p>
        </Grid>

        {/* First Column */}
        <Grid item xs={12} sm={4}>
          <TextField
            id="outlined-required"
            label="Robot ID"
            defaultValue=""
            name="robot_id"
            fullWidth
            onChange={handleChange}
          />
          <TextField
            id="outlined-required"
            label="Robot Deployed Date"
            defaultValue=""
            name="robot_deployed_date"
            fullWidth
            sx={{ mt: 2 }}
            onChange={handleChange}
          />
          <TextField
            required
            select
            id="outlined-required"
            label="Polyedge Version"
            defaultValue=""
            name="robot_software"
            fullWidth
            sx={{ mt: 2 }}
            onChange={handleChange}
          >
            {robot_softwares.map((option) => (
              <MenuItem key={option.Id} value={option.Id}>
                {option.Name} {option.Version}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Second Column */}
        <Grid item xs={12} sm={4}>
          <TextField
            required
            select
            id="outlined-required"
            label="Robot Type"
            defaultValue=""
            name="robot_type"
            fullWidth
            onChange={handleChange}
          >
            {robot_types.map((option) => (
              <MenuItem key={option.Id} value={option.Id}>
                {option.Name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            id="outlined-required"
            label="Robot Decommission Date"
            defaultValue=""
            name="robot_decom_date"
            fullWidth
            sx={{ mt: 2 }}
            onChange={handleChange}
          />
          <TextField
            select
            required
            id="outlined-required"
            label="Robot Version"
            defaultValue=""
            name="robot_version"
            fullWidth
            sx={{ mt: 2 }}
            onChange={handleChange}
          >
            {robot_versions.map((option) => (
              <MenuItem key={option.Id} value={option.Id}>
                {option.Version}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Third Column */}
        <Grid item xs={12} sm={4}>
          <TextField
            id="outlined-required"
            label="Robot Organisation"
            defaultValue=""
            name="robot_org"
            fullWidth
            onChange={handleChange}
          />
          <TextField
            select
            required
            id="outlined-required"
            label="Robot Site"
            defaultValue=""
            name="robot_site"
            fullWidth
            sx={{ mt: 2 }}
            onChange={handleChange}
          >
            {robot_sites.map((option) => (
              <MenuItem key={option.Id} value={option.Id}>
                {option.Site}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            id="outlined-required"
            label="Robot Map"
            defaultValue=""
            name="robot_map"
            fullWidth
            sx={{ mt: 2 }}
            onChange={handleChange}
          >
            {robot_maps.map((map, index) => (
              <MenuItem key={index} value={map}>
                {map}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Action Buttons */}
        <Grid item xs={12} display="flex" justifyContent="flex-end">
          <Button onClick={formSubmit} variant="contained" sx={{ mr: 2 }}>
            Submit
          </Button>
          <Button onClick={formClose} variant="outlined">
            Close
          </Button>
        </Grid>
      </Grid>
    </Box>
  </Modal>
  )
}